import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-forgot-password-status',
    templateUrl: './forgot-password-status.component.html',
    standalone: true,
    imports: [CommonModule, MatIconModule, TranslateModule, RouterModule],
    styles: [
        `
            :host {
                width: 100%;
            }
        `,
    ],
    styleUrls: ['./forgot-password-status.component.scss'],
})
export class ForgotPasswordStatusComponent {
    constructor(private router: Router) {}

    goToResetPassword() {
        this.router.navigate(['/reset-password']);
    }

    onResendEmail() {
        this.router.navigate(['/forgot-password']);
    }
}
